import {Component, Vue} from 'vue-property-decorator';

@Component
export default class FormatMixin extends Vue {
  phoneNumber(phoneNumber: string) {
    let formattedPhoneNumber = phoneNumber;
    if (phoneNumber && phoneNumber.length) {
      let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
      if (!phoneNumberArray) {
        return formattedPhoneNumber;
      }
      formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
      for (let i = 1; i < phoneNumberArray.length; i++) {
        if (phoneNumberArray[i]) {
          formattedPhoneNumber += phoneNumberArray[i] + '.';
        }
      }
      formattedPhoneNumber = formattedPhoneNumber.slice(0, formattedPhoneNumber.length - 1);
    } else {
      formattedPhoneNumber = 'NA';
    }
    return formattedPhoneNumber;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/mixins/FormatMixin.ts